import { Dialog } from '@mui/material';
import React from 'react';

export interface WsDialogProps {
  onClose?: () => void;
  openDialog: boolean;
  children: React.ReactNode;
  size?: string;
  fullScreen?: boolean;
}
export enum WsDialogSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  EXTRALARGE = 'extraLarge',
  EXTRASMALL = 'extraSmall',
  SQUARE = 'square',
}
const mapWsDialogSize = new Map();
mapWsDialogSize.set('extraSmall', 'xs');
mapWsDialogSize.set('small', 'sm');
mapWsDialogSize.set('medium', 'md');
mapWsDialogSize.set('large', 'lg');
mapWsDialogSize.set('extraLarge', 'xl');

const WsDialog: React.FC<WsDialogProps> = ({
  onClose,
  openDialog,
  children,
  size,
  fullScreen = false,
}) => {
  const isSquare = size === WsDialogSize.SQUARE;
  return (
    <Dialog
      onClose={onClose}
      fullScreen={fullScreen}
      open={openDialog}
      fullWidth={!isSquare}
      style={{ zIndex: '1300' }}
      maxWidth={isSquare ? false : mapWsDialogSize.get(size)}
      PaperProps={
        isSquare
          ? {
              sx: {
                width: 400,
                height: 400,
                borderRadius: 4,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              },
            }
          : {}
      }
    >
      {children}
    </Dialog>
  );
};

export default WsDialog;
